import api, { apiPrefix } from './Api';
import { Blog, blogFromResponse } from '../interfaces/Blog/Blog';

const blogApiPrefix = `${apiPrefix}/blogs`;

export const getBlogs = async (): Promise<Blog[]> => {
  const response = await api.get(blogApiPrefix);

  return (response.data?.data ?? []).map((blog: any) => blogFromResponse(blog));
};

export const getBlog = async (slug: string): Promise<Blog> => {
  const response = await api.get(`${blogApiPrefix}/${slug}`);

  return blogFromResponse(response.data?.data);
};
